import client from './client';

export interface CurrencyBank {
  id: number;
  bank_code: string;
  bank_name: string;
  bank_short: string;
  usd_buy: number | null;
  usd_sell: number | null;
  eur_buy: number | null;
  eur_sell: number | null;
  rub_buy: number | null;
  rub_sell: number | null;
  source_url: string | null;
  sort_order: number;
  is_active: boolean;
  updated_at: string | null;
}

export interface CurrencyUpdatePayload {
  usd_buy?: number | null;
  usd_sell?: number | null;
  eur_buy?: number | null;
  eur_sell?: number | null;
  rub_buy?: number | null;
  rub_sell?: number | null;
  is_active?: boolean;
  sort_order?: number;
}

export interface CurrencyRefreshResult {
  result: { updated: number; failed: number };
  banks: CurrencyBank[];
}

export const currencyApi = {
  list: () => client.get<CurrencyBank[]>('/api/admin/currency'),

  refresh: () => client.post<CurrencyRefreshResult>('/api/admin/currency/refresh'),

  update: (id: number, data: CurrencyUpdatePayload) =>
    client.patch<CurrencyBank>(`/api/admin/currency/${id}`, data),
};
